import React from "react";

const SectionWithNoBorder = (props) => {
    return (
                <div className="" >
                    <div className={`grid grid-cols-3 gap-4 h-auto  w-full flex items-center`}>
                        <h2 className="text-base text-[#757575] font-bold">{props.column1}</h2>
                        <h2 className="text-base text-[#757575] font-bold">{props.column2}</h2>
                        <h2 className="text-base text-[#757575] font-bold">{props.column3}</h2>
                    </div>
                    {props.children}
                </div>
    );
};
export default SectionWithNoBorder;